import { VALUATION_MY_HOME_V2 } from '../../../constants/experiments';
import { IApplicationState } from '../../../types/redux';
import { isExperimentActive } from '../../../utils/experiments';
import { selectExperiments } from '../experiments';

export const selectIsMyHomeRedesign = (state: IApplicationState) => {
  const experiments = selectExperiments(state);

  const isGroupNameB = isExperimentActive(experiments, VALUATION_MY_HOME_V2, 'B');
  const isGroupNameC = isExperimentActive(experiments, VALUATION_MY_HOME_V2, 'C');

  return isGroupNameB || isGroupNameC;
};
